import { SegmentType } from '@ve-pro/enums/segment'
import type {
  SegmentCollection,
  SegmentFragment,
  SegmentVideo,
  Track,
} from '@ve-pro/types/track.type'
import { useTrackStore } from '.'
import {
  getTransitionById,
  removeTransition,
  updateTransition,
} from './segment/segment-transition'
import { framesToDuration } from './frame'
let _enableUpdateMainTrack = true

export function setEnableUpdateMainTrack(enable: boolean): void {
  _enableUpdateMainTrack = enable
}
/**
 * 获取主轨道元件按入场时间排序后的集合
 */
export function getSortedSegments(options?: {
  ignoreSegments?: SegmentCollection[]
  track?: Track
}): SegmentVideo[] | SegmentFragment[] {
  const trackStore = useTrackStore()
  const tartgetTrack = options?.track ?? trackStore.mainTack

  const segments = tartgetTrack?.segments
    .filter(
      (s) =>
        [SegmentType.Video, SegmentType.Fragment].includes(s.type) &&
        !options?.ignoreSegments?.some((ignore) => ignore.id === s.id),
    )
    .sort((a, b) => a.start_time - b.start_time)

  return (segments ?? []) as any
}

export function updateMainTrack(
  force = true,
  options?: {
    mainTrack?: Track
    ignoreSegments?: SegmentCollection[]
  },
): number {
  const trackStore = useTrackStore()

  const targetMainTrack = options?.mainTrack ?? trackStore.mainTack
  // 按入场时间排序
  const sortedSegments = getSortedSegments({
    ignoreSegments: options?.ignoreSegments,
    track: targetMainTrack ?? undefined,
  })
  if (!_enableUpdateMainTrack) {
    const last = sortedSegments[sortedSegments.length - 1]
    return last ? last.start_time + last.duration : 0
  }

  if (force) {
    // 重新建立关系
    sortedSegments.forEach((currentSeg, index) => {
      const before_transition = currentSeg.before_transition_id
        ? getTransitionById(currentSeg.before_transition_id)
        : null

      if (
        index === 0 ||
        (before_transition && before_transition.behind.id !== currentSeg.id)
      ) {
        currentSeg.before_transition_id = null
      }

      const behind_transition = currentSeg.behind_transition_id
        ? getTransitionById(currentSeg.behind_transition_id)
        : null

      const nextSegment = sortedSegments[index + 1]

      if (behind_transition) {
        if (nextSegment) {
          behind_transition.behind = nextSegment
          nextSegment.before_transition_id = behind_transition.id
        } else {
          // 也取消后面的关联
          currentSeg.behind_transition_id = null
        }
      }
    })

    targetMainTrack?.segments.forEach((s) => {
      if (s.type === SegmentType.Transition) {
        if (
          s.before.behind_transition_id !== s.id ||
          s.behind.before_transition_id !== s.id
        ) {
          // removeSegment(s)
          removeTransition(s)
        }
      }
    })
  }

  let startFrame = 0
  sortedSegments.forEach((currentSeg) => {
    const before_transition = currentSeg.before_transition_id
      ? getTransitionById(currentSeg.before_transition_id)
      : null

    const behind_transition = currentSeg.behind_transition_id
      ? getTransitionById(currentSeg.behind_transition_id)
      : null

    if (before_transition) {
      updateTransition(before_transition, force)
    }

    if (behind_transition) {
      updateTransition(behind_transition, force)
    }

    // 注意：单独的逻辑，由于上面的update可能导致 currentSeg.before_transition 被删除
    if (before_transition && before_transition.overlap) {
      const { duration_frames } = before_transition
      currentSeg.start_frame = Math.floor(startFrame - duration_frames)

      startFrame = Math.floor(
        startFrame + currentSeg.duration_frames - duration_frames,
      )
    } else {
      currentSeg.start_frame = startFrame
      startFrame = Math.floor(startFrame + currentSeg.duration_frames)
    }
  })

  if (
    targetMainTrack &&
    trackStore.defaultExcludeFragmentMainTrack &&
    targetMainTrack.id !== trackStore.defaultExcludeFragmentMainTrack.id
  ) {
    updateMainTrack(force, {
      mainTrack: trackStore.defaultExcludeFragmentMainTrack,
    })
  }

  return framesToDuration(startFrame)
}
